/**
 * 公共服务调取
 */

import store from "@/store";
import { Message } from "view-design";

// 将返回的数据处理成树结构key值
// type 0 获取菜单数据  1获取按钮数据
let mapTree = (org, type = 0) => {
  const haveChildren = Array.isArray(org.sub_list) && org.sub_list.length > 0;
  let ResultInfo = {};
  let NowChildren = null;
  if (haveChildren) {
    NowChildren = org.sub_list;
    delete org.sub_list;
  }
  ResultInfo = { ...org };
  //展示的名字
  ResultInfo.title = org.rs_cn_name;

  // 默认选中的节点 父节点不考虑
  if (!haveChildren) {
    // 菜单资源
    if (type == 0 && org.count_prit > 0) {
      ResultInfo.checked = true;
    }
    // 按钮资源
    if (type == 1) {
      org.count_prit <= 0
        ? (ResultInfo.checked = true)
        : (ResultInfo.checked = false);
      org.rs_level > 1
        ? (ResultInfo.title = `${ResultInfo.title} — ${org.rs_bk_desc}`)
        : ResultInfo.title;
    }
  }
  if (haveChildren) {
    ResultInfo.children = NowChildren.map((i) => mapTree(i, type));
  }
  return ResultInfo;
};
/**
 * 获取相应的菜单权限列表信息
 *
 */
const sys_getMenuPermission = async (params, type = 0) => {
  // 获取登录人信息
  const NowUserInfo = JSON.parse(store.getters.getCommData);
  let resultInfo = null;
  // 判断是否是admin用户
  params = Object.assign(params, { cull_type: "cull" });
  // if (NowUserInfo.org_user_id != "admin") {
  //   params = Object.assign(params, { cull_type: "cull" });
  // }
  resultInfo = await store.dispatch(
    "DelResByCodeView_queryInfosByRsCodeOfAdmin",
    params
  );

  if (resultInfo) {
    let { request_state, infos } = resultInfo;
    if (request_state) {
      let resultList = null;
      if (infos.length > 0) {
        resultList = infos.map((item) => mapTree(item, type));
      }
      return resultList;
    } else {
      Message.error("获取权限配置信息失败！");
      return null;
    }
  } else {
    Message.error("获取权限配置信息失败！");
    return null;
  }
};

/**
 * 设置菜单权限 企业/部门使用
 */
const sys_setMenuPermission = async (params) => {
  let resultInfo = await store.dispatch("UpdateDeptRsOptPrivAction", params);
  if (resultInfo) {
    let { request_state } = resultInfo;
    if (request_state) {
      return request_state;
    } else {
      Message.error("配置企业/部门权限失败！");
      return null;
    }
  } else {
    Message.error("配置企业/部门权限失败！");
    return null;
  }
};

/**
 * 设置菜单权限 用户使用
 */
const sys_setMenuPermissionByUser = async (params) => {
  let resultInfo = await store.dispatch("UpdateUserRsOptPrivAction", params);
  if (resultInfo) {
    let { request_state } = resultInfo;
    if (request_state) {
      return request_state;
    } else {
      Message.error("配置用户权限失败！");
      return null;
    }
  } else {
    Message.error("配置用户权限失败！");
    return null;
  }
};

/**
 * 设置菜单权限 部门角色使用
 */
const sys_setMenuPermissionBydeprole = async (params) => {
  let resultInfo = await store.dispatch("UpdateDprlRsOptPrivAction", params);
  if (resultInfo) {
    let { request_state } = resultInfo;
    if (request_state) {
      return request_state;
    } else {
      Message.error("配置部门角色权限失败！");
      return null;
    }
  } else {
    Message.error("配置部门角色权限失败！");
    return null;
  }
};

export {
  sys_getMenuPermission,
  sys_setMenuPermission,
  sys_setMenuPermissionByUser,
  sys_setMenuPermissionBydeprole,
};
